import { Helmet } from 'react-helmet';
import { SEOMetaTags } from '../../copy';

function SEO(props) {
    const { url } = props;
    const content = SEOMetaTags[url] || SEOMetaTags.default;

    return (
        <Helmet>
            <title>{content.title}</title>
            <meta name="description" content={content.description} />
            <meta name="keywords" content={content.keywords} />
        </Helmet>
    );
}

export default SEO;
